<div class="container" [class]="{ activeBg: isActive() }">
    <span>
        <div class="label" [class]="{ activeLabel: isActive() }">
            <p class="prevent-selection">{{ label }}</p>
        </div>
        <div class="iconPlus">
            <img src="assets/img/icons/svg/plus_no_border.svg" alt="Zertifizierung anlegen">
        </div>
    </span>
</div>